/* eslint-disable unicorn/filename-case */
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

export type ISettingsParams = {
  formId: SettingsParamType.String;
  presetId: SettingsParamType.String;
};

export default createSettingsParams<ISettingsParams>({
  formId: {
    type: SettingsParamType.String,
    getDefaultValue: () => '',
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  presetId: {
    type: SettingsParamType.String,
    getDefaultValue: () => '',
  },
});
